<script lang="ts">
  import * as _ from "lodash";
  import type { Storefront } from "@shared/types/Storefront";
  import type { ProductLine } from "@shared/types/ProductLine";
  import ProductCard from "@shared/svelte/Components/ProductLines/ProductCard.svelte";
  import Pagination from "../Pagination/Large.svelte";
  import type { FiltersType, Filter } from "@shared/types/Filters";
  import UIRouterLink from "../UIRouterLink.svelte";

  export let storefront: Storefront;
  export let callbacks: any;

  let params = {
    search: null,
    brand_family_id: null,
    category_id: null,
  };
  let filters: FiltersType;
  let catalog: ProductLine[] = storefront.catalog;
  let storefrontDistributor = storefront.distributor || {};

  let catalogContainer: HTMLElement;
  let currentSort = storefront.catalog_sort_by;
  let currentPerPage = storefront.catalog_items_per_page;

  const pullFilters = function () {
    callbacks.pullAvailableFilters(params).then(
      function success(res: any) {
        filters = res.xhrStatus ? res.data : res;
        params = {
          search: params.search,
          brand_family_id: params.brand_family_id,
          category_id: params.category_id,
        };
      },
      function error(res: any) {
        console.error(res);
      },
    );
  };

  function prepCats(cats: any): Filter[] {
    return _.uniqBy(cats, function (x: any) {
      return x.name;
    });
  }

  const pullCatalog = function () {
    callbacks.pullCatalog(params);
    pullFilters();
  };

  const runSearch = function () {
    params.brand_family_id = null;
    params.category_id = null;
    pullCatalog();
  };

  const changeCategory = function () {
    params.search = null;
    pullCatalog();
  };

  let resetScroll = function () {
    let headerOffset: number =
      document.getElementsByTagName("header")[0] != undefined
        ? document.getElementsByTagName("header")[0].offsetHeight + 20
        : 0;
    let yCoord = catalogContainer.offsetTop - headerOffset;
    setTimeout(() => {
      window.scrollTo({ left: 0, top: yCoord, behavior: "smooth" });
    }, 150);
  };

  $: {
    catalog = storefront.catalog;
    storefrontDistributor = storefront.distributor || {};
  }

  $: {
    if (
      storefront.catalog_sort_by !== currentSort ||
      storefront.catalog_items_per_page !== currentPerPage
    ) {
      params = {
        search: null,
        brand_family_id: null,
        category_id: null,
      };
      currentSort = storefront.catalog_sort_by;
      currentPerPage = storefront.catalog_items_per_page;
    }
  }

  function sortFilters(a: any, b: any) {
    let nameA = (a.name || "zzzz").toUpperCase();
    let nameB = (b.name || "zzzz").toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }
  pullFilters();
</script>

{#if storefront.enable_catalog}
  <section id="product_catalog" bind:this={catalogContainer}>
    <div class="fizz-flex-row-responsive fizz-space-between fizz-stack-16">
      <h3 class="fizz-heading-3">Shop All {storefront.distributor.name} Products</h3>
      <div class="fizz-text-strong">
        <UIRouterLink
          stateName="layout.product_listing"
          params={{ distributors: storefront.distributor_id }}
        >
          View entire catalog
        </UIRouterLink>
      </div>
    </div>

    {#if catalog && filters}
      <form class="fizz-flex-row-responsive fizz-stack-32" on:submit|preventDefault>
        <input
          type="text"
          id="search"
          name="search"
          placeholder="Search {storefront.distributor.name}"
          class="fizz-input-text fizz-flex-item"
          bind:value={params.search}
          on:change|preventDefault={runSearch}
        />
        <select
          id="select-category"
          class="fizz-select fizz-full-width"
          bind:value={params.category_id}
          on:change|preventDefault={changeCategory}
        >
          <option value={null}>Category</option>
          {#each prepCats(filters.category).sort(sortFilters) as cat}
            <option value={cat.id}>{cat.name}</option>
          {/each}
        </select>
        <select
          id="select-brand"
          class="fizz-select fizz-full-width"
          bind:value={params.brand_family_id}
          on:change|preventDefault={changeCategory}
        >
          <option value={null}>Brand Family</option>
          {#each (filters.brandFamily || []).sort(sortFilters) as bf}
            <option value={bf.id}>{bf.name}</option>
          {/each}
        </select>
      </form>
      <div class="fizz-grid fizz-stack-32" style="--grid-col-min: 160px; --grid-col-max: 224px;">
        {#each catalog as productLine, index (productLine.id)}
          <div id={`product_line_${productLine.id}`} product-line-id={productLine.id}>
            <ProductCard
              {productLine}
              {index}
              inventoryPrices={storefront.inventoryPrices || []}
              userIsAdmin={false}
              distributorOverride={{
                id: storefrontDistributor.id,
                name: storefrontDistributor.name,
              }}
            />
          </div>
        {/each}
      </div>
      <Pagination bind:pagination={storefront.catalogPagination} on:paginationEvent={resetScroll} />
    {:else}
      <div class="catalog-spacetaker" style="height: 1000px;" />
    {/if}
  </section>
{/if}
